import {Autocomplete, TextField} from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

export const SVPAutocomplete = ({
    options,
    onChange,
    value,
    footerText,
    isDisabled = false,
    isDisableInactiveOptions = false,
}) => {
    return (
        <>
            <Autocomplete
                disablePortal={true}
                options={options}
                onChange={onChange}
                renderInput={(params) => <TextField {...params} />}
                size="small"
                value={value}
                sx={{
                    "& .MuiInputBase-root": {
                        "backgroundColor": "white",
                        "&.Mui-disabled": {
                            backgroundColor: "#f5f5f5",
                        },
                    },
                }}
                clearIcon={null}
                disabled={isDisabled}
                getOptionDisabled={isDisableInactiveOptions ? (option) => !option.is_active : null}
            />
            {footerText}
        </>);
};

SVPAutocomplete.propTypes = {
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
    footerText: PropTypes.node,
    isDisabled: PropTypes.bool,
    isDisableInactiveOptions: PropTypes.bool,
};
